import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Cookies from "js-cookie";
import { Locale } from "../hooks/Locale";
import { LocalStorageKey, LocalStorageUtils } from "./LocalStorageUtils";
function toLocale(localeStr) {
  var _countryRegion$, _countryRegion$2;
  if (!localeStr) {
    return;
  }
  var locale;
  var countryRegion = localeStr.split(/-|_/);
  var country = (_countryRegion$ = countryRegion[0]) === null || _countryRegion$ === void 0 ? void 0 : _countryRegion$.toLowerCase();
  var region = (_countryRegion$2 = countryRegion[1]) === null || _countryRegion$2 === void 0 ? void 0 : _countryRegion$2.toUpperCase();
  if (country === "en") {
    locale = Locale.enUS;
  } else if (country === "zh") {
    if (region === "CN") {
      locale = Locale.zhCN;
    } else {
      locale = Locale.zhTW;
    }
  } else {
    locale = country;
  }
  return locale;
}
export function getCurrentLocale() {
  var defaultLocale = Locale.enUS;
  var match = window.location.pathname.match(/^\/([^\/ ]+)/);
  var urlLocal = !!match && toLocale(match[1]);
  var storageLocale = toLocale(LocalStorageUtils.get(LocalStorageKey.CONFIG_LOCALE) || Cookies.get("locale") || "");
  var acceptLanguage = toLocale(window.navigator.language || window.navigator["browserLanguage"]);
  var locale = urlLocal || storageLocale || acceptLanguage || defaultLocale;
  return locale;
}
/* 获取当前子域名 */
export function getCurrentSubdomain() {
  try {
    var subdomain = "";
    var key = "mh_".concat(Math.random());
    var _document = document,
      domain = _document.domain;
    var domainList = domain.split(".");
    var ipAddressReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
    // 若为 IP 地址、localhost，则直接返回
    if (ipAddressReg.test(domain) || domain === "localhost") {
      return domain;
    }
    var urlItems = [];
    urlItems.unshift(domainList.pop());
    while (domainList.length) {
      urlItems.unshift(domainList.pop());
      subdomain = urlItems.join(".");
      Cookies.set(key, "12345", {
        domain: subdomain
      });
      if (Cookies.get(key)) {
        Cookies.remove(key, {
          domain: subdomain
        });
        break;
      }
    }
    return subdomain || document.domain;
  } catch (e) {
    return document.domain;
  }
}
var Constants = /*#__PURE__*/function () {
  function Constants() {
    _classCallCheck(this, Constants);
  }
  _createClass(Constants, null, [{
    key: "accountsRootPath",
    get:
    // 当前子域名

    function get() {
      return "https://".concat(this.accountsDomain, "/").concat(getCurrentLocale());
    }
  }, {
    key: "accountsRoute",
    get: function get() {
      return {
        resetPassword: "".concat(this.accountsRootPath, "/ResetPassword"),
        resetSecurityAccount: "".concat(this.accountsRootPath, "/ResetSecurityAccount")
      };
    }
  }]);
  return Constants;
}();
_defineProperty(Constants, "origin", window.location.origin);
_defineProperty(Constants, "host", window.location.host);
_defineProperty(Constants, "currentSubdomain", getCurrentSubdomain());
_defineProperty(Constants, "accountsDomain", "accounts.".concat(Constants.currentSubdomain === "localhost" ? "pionexdev.com" : Constants.currentSubdomain));
export { Constants as default };